import html from "./html";
import react from "./react/react";
import reactStatic from "./react/static";

export default { html, react, reactStatic };
